/**
 * Custom tags that are used to identify errors in Sentry.
 */
export enum SentryTags {
    /**
     * Current screen being viewed.
     */
    UI_SCREEN = 'ui_screen',

    /**
     * Category of the error.
     */
    ERROR_CATEGORY = 'error_category',

    /**
     * API operation ID.
     */
    API_OPERATION = 'api_operation',

    /**
     * API operation first tag.
     */
    API_OPERATION_TAG = 'api_operation_tag',

    /**
     * Billing plan of the organization.
     */
    ORGANIZATION_PLAN = 'organization_plan',
}
